import { React, EyeIcon, LogOutIcon, useNavigate } from "../vendor/runtime.js";
import { useAdminAuth } from "../context/AdminAuthContext.jsx";

export const LoginPage = () => {
  const [credentials, setCredentials] = React.useState({ email: "", password: "" });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const change = ({ target: { name, value } }) => setCredentials((previous) => ({ ...previous, [name]: value }));
  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      if (await login(credentials.email, credentials.password)) navigate("/admin");
      else setError("Failed to login. Please check your credentials.");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to login. Please check your credentials or contact support.");
    } finally { setLoading(false); }
  };
  return <main className="admin-login">
    <section className="admin-login-card" aria-labelledby="login-title">
      <div className="admin-login-logo"><img src="/Logo.png" alt="CodeBruh" /></div>
      <div className="admin-login-brand"><h1>CodeBruh Admin</h1><p>Management System</p><span aria-hidden="true">◆</span></div>
      <h2 id="login-title">Welcome Back</h2>
      <p className="admin-login-intro">Sign in to manage your products, people and orders.</p>
      {error && <div className="admin-alert" role="alert">{error}</div>}
      <form onSubmit={submit}>
        <label htmlFor="email">Email address</label>
        <input id="email" name="email" type="email" autoComplete="email" required placeholder="Enter your email address" value={credentials.email} onChange={change} />
        <label htmlFor="password">Password</label>
        <div className="admin-password-field">
          <input id="password" name="password" type={showPassword ? "text" : "password"} autoComplete="current-password" required placeholder="Enter your password" value={credentials.password} onChange={change} />
          <button type="button" className="admin-icon-button" aria-label={showPassword ? "Hide password" : "Show password"} aria-pressed={showPassword} onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M3 3l18 18M10.6 10.6a2 2 0 002.8 2.8M9.5 5.3A11 11 0 0112 5c6 0 10 7 10 7a19 19 0 01-3.2 3.9M6.3 6.3A20 20 0 002 12s4 7 10 7a11 11 0 005.7-1.7" /></svg> : <EyeIcon size={19} />}
          </button>
        </div>
        <button type="submit" className="admin-button admin-login-submit" disabled={loading}>
          <LogOutIcon size={18} aria-hidden="true" />{loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
      <p className="admin-login-footer">CodeBruh · Administrator access</p>
    </section>
  </main>;
};
